/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ContentContainer } from '@/components/ContentContainer';
import { PageHeader } from '@/components/PageHeader';
import { QueryWrapper } from '@/components/QueryWrapper';
import { usePaginatedUserActivityQuery } from '@/hooks/query/usePaginatedUserActivityQuery';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { UserActivityTable } from '@/pages/UserActivity/UserActivityTable';
import { Container } from '@/primitives/Container';

export function UserActivityPage() {
  const { t } = useMimicTranslation('userActivity');

  const userActivityQuery = usePaginatedUserActivityQuery({
    type: 'queryParams',
    params: {
      filters: {
        excludeEndpoints: '/api/activity,/api/users/profile',
      },
    },
  });

  return (
    <ContentContainer width="100%">
      <Container full style={{ width: '100%' }}>
        <PageHeader title={t('title')} level={2} />
        <QueryWrapper queryResult={userActivityQuery}>
          {(userActivityData) => (
            <UserActivityTable
              data={userActivityData}
              updateQueryParams={userActivityQuery.updateQueryParams}
              filters={userActivityQuery.filters}
            />
          )}
        </QueryWrapper>
      </Container>
    </ContentContainer>
  );
}
